import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

function TypeformCta({ isActive }) {
    if (!isActive) return null;
    return (
        <a
            className="typeform-share link link--cta"
            href="https://99designs1.typeform.com/to/g9Yzq9"
            data-mode="drawer_left"
        >
            <FormattedMessage id="feedback_link" />
        </a>
    );
}
TypeformCta.defaultProps = {
    isActive: true,
};

TypeformCta.propTypes = {
    isActive: PropTypes.bool,
};

export default TypeformCta;



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/TypeformCta.jsx